export const VAPID_KEY="BCqbzWaA-9VxU-oUPqlIYC-phZhRlVUjR8kNpCPw22U_2vMiHmUo6CSiQ_3VB2HGPTibsKoAk-Yj3_SM1aQ5BtY";
export const WEB_PUSH_PROPOSAL_TIME= 7 * 24 * 60 * 60 * 1000;
